import { ImageCard, GridLayout } from '../ui'
import { Link, RouteComponentProps } from '@reach/router'
import React, { FC } from 'react'
import stopwatch from '../assets/stopwatch.jpg'
import exportimport from '../assets/exportimport.jpg'

export const Home: FC<RouteComponentProps> = () => {
  return (
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <GridLayout>
        <Link to="/events">
          <ImageCard imageSrc={stopwatch}>Dive into the event stream</ImageCard>
        </Link>
        <Link to="/export-import">
          <ImageCard imageSrc={exportimport}>Export/Import pathways</ImageCard>
        </Link>
      </GridLayout>
    </div>
  )
}

Home.displayName = 'Home'
